import React, { useEffect, useContext, lazy, Suspense } from "react"

import { Global, css } from "@emotion/react"

import ScrollListener from "components/ScrollListener"
import IntersectionObserverPolyfill from "components/IntersectionObserverPolyfill"
import AppProvider, { AppContext } from "src/state/AppState"

import NewsletterButton from "src/components/NewsletterButton"
import MixpanelPageView from "src/components/MixpanelPageView"

import globalStyles from "styles/globalStyles"

/* reset.css moved to global.css @layer base so Tailwind utilities (p-*, m-*) win */

const NewsletterModal = lazy(() => import("src/components/NewsletterModal"))
const DownloadModal = lazy(() => import("src/components/DownloadModal"))
const FreeModal = lazy(() => import("src/components/FreeModal"))

// Handles opening modals via query parameter (e.g., ?modal=download-modal)
const ModalQueryHandler = () => {
  const { toggleModal } = useContext(AppContext)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search)
      const modalParam = params.get("modal")
      if (modalParam) {
        toggleModal(modalParam)
      }
    }
  }, [toggleModal])

  return null
}

// Wrapper structure matches other site (Next.js): min-h-dvh, flex, safe-area padding
const Layout = ({ children }) => (
  <>
    <Global
      styles={css`
        @layer marketing-components {
          ${globalStyles}
        }
      `}
    />
    <div
      id="pageTop"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "1px",
        margin: 0,
        padding: 0,
        pointerEvents: "none",
      }}
      aria-hidden="true"
    />
    <IntersectionObserverPolyfill>
      <AppProvider>
        <ModalQueryHandler />
        <MixpanelPageView />
        <ScrollListener>
          <NewsletterButton />
          <div className="min-h-dvh flex flex-col">
            <div className="flex-1 w-full pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)]">
              <main id="main-content">{children}</main>
            </div>
          </div>
        </ScrollListener>
        <Suspense fallback={null}>
          <NewsletterModal />
          <DownloadModal />
          <FreeModal />
        </Suspense>
      </AppProvider>
    </IntersectionObserverPolyfill>

    <svg
      style={{ width: 0, height: 0, position: "absolute" }}
      aria-hidden="true"
      focusable="false"
    >
      <linearGradient
        id="logo-gradient"
        x1="0.111298"
        y1="0.432181"
        x2="0.801716"
        y2="0.807377"
      >
        <stop offset="0" stopColor="#7B61FF" />
        <stop offset=".9" stopColor="#FD5F5E" />
      </linearGradient>
    </svg>
  </>
)

export default Layout
